import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";

declare var ko: any;

export class newsletterTargetingBuilder_template extends vnTemplate {
    private dateFilterId: number = 0;
    private loadedProfileOptionFields: any = {};

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="newsletter-targeting-builder">


                <div data-bind="foreach: filterGroups">
                    <div class="targeting-group-join" data-bind="visible: $index() > 0">

                        <div class="form-group">
                            <select class="input-select" data-bind="value: joinWithPrevious, disable: $parent.isReadOnly">
                                <option value="AND">AND</option>
                                <option value="OR">OR</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group targeting-group">
                        <div class="form-group targeting-group-title">
                            <label class="form-label">Filter Group</label>
                            <button type="button" class="btn border only-icon icon i-delete targeting-group-remove" title="Remove Group" aria-label="Remove Group" data-bind="visible: !$parent.isReadOnly(), event: { click: $parent.removeFilterGroup.bind($parent, $data) }"></button>
                        </div>
                        <div class="form-group targeting-conditions" data-bind="foreach: conditions">
                            ${this.getConditionJoinHtml()}
                            ${this.getConditionHtml()}
                        </div>
                        <div class="form-group targeting-group-controls">
                            <button type="button" class="btn secondary icon i-add" data-bind="visible: !$parent.isReadOnly(), event: { click: $parent.addCondition.bind($parent, $data) }">Add Condition</button>
                        </div>
                    </div>
                </div>

                <div class="form-group targeting-exclusion-note" data-bind="visible: exclusionGroups().length > 0"><p class="form-text">Exclusion groups are applied as AND NOT.</p></div>

                <div data-bind="foreach: exclusionGroups">
                    <div class="form-group targeting-group targeting-exclusion-group">
                        <div class="form-group targeting-group-title">
                            <label class="form-label">Exclusion Group</label>
                            <button type="button" class="btn border only-icon icon i-delete targeting-group-remove" title="Remove Group" aria-label="Remove Group" data-bind="visible: !$parent.isReadOnly(), event: { click: $parent.removeExclusionGroup.bind($parent, $data) }"></button>
                        </div>
                        <div class="form-group targeting-conditions" data-bind="foreach: conditions">
                            ${this.getConditionJoinHtml()}
                            ${this.getConditionHtml()}
                        </div>
                        <div class="form-group targeting-group-controls">
                            <button type="button" class="btn secondary icon i-add" data-bind="visible: !$parent.isReadOnly(), event: { click: $parent.addCondition.bind($parent, $data) }">Add Condition</button>
                        </div>
                    </div>
                </div>
                <div class="form-group targeting-filter-toolbar">
                    <div class="targeting-filter-actions" data-bind="visible: !isReadOnly()">
                        <button type="button" class="btn secondary icon i-add" data-bind="event: { click: addFilterGroup }">Add Filter Group</button>
                        <button type="button" class="btn secondary icon i-add" data-bind="event: { click: addExclusionGroup }">Add Exclusion Group</button>
                    </div>
                </div>

            </div>
        `;
    }

    private getConditionJoinHtml(): string {
        return /*html*/`
            <div class="targeting-condition-join" data-bind="visible: $index() > 0">
                <div class="form-group">
                    <select class="input-select" data-bind="value: $parent.combinator, disable: $parents[1].isReadOnly">
                        <option value="AND">AND</option>
                        <option value="OR">OR</option>
                    </select>
                </div>
            </div>
        `;
    }

    private getConditionHtml(): string {
        return /*html*/`
            <div class="targeting-condition">
                <div class="targeting-condition-layout">
                    <div class="targeting-condition-rule">
                        <div class="form-group targeting-condition-field">
                            <label class="form-label">Field</label>
                            <div class="targeting-condition-field-control">
                                <select class="input-select" data-bind="options: $parents[1].fields, optionsText: 'label', optionsValue: 'id', value: field, disable: $parents[1].isReadOnly"></select>
                            </div>
                            <div class="form-group checkbox-fix targeting-condition-external-users" data-bind="visible: showExternalUsers">
                                <input type="checkbox" data-bind="checked: includeExternalUsers, disable: $parents[1].isReadOnly, attr: { id: 'include-external-' + $parents[1].uniqueId() + '-' + $parentContext.$index() + '-' + $index() }">
                                <label class="form-label icon i-check" data-bind="attr: { for: 'include-external-' + $parents[1].uniqueId() + '-' + $parentContext.$index() + '-' + $index() }">Allow External Users</label>
                            </div>
                            <div class="form-group checkbox-fix targeting-condition-repeat-yearly" data-bind="visible: fieldType() === 'birthday'">
                                <input type="checkbox" data-bind="checked: repeatsEveryYear, disable: $parents[1].isReadOnly, attr: { id: 'repeat-yearly-' + $parents[1].uniqueId() + '-' + $parentContext.$index() + '-' + $index() }">
                                <label class="form-label icon i-check" data-bind="attr: { for: 'repeat-yearly-' + $parents[1].uniqueId() + '-' + $parentContext.$index() + '-' + $index() }">Repeats Dates Every Year</label>
                            </div>
                            <div class="form-group targeting-condition-utm-source" data-bind="visible: $parents[1].isUtmSourceField(field())">
                                <label class="form-label">UTM Source</label>
                                <select class="input-select" data-bind="options: $parents[1].utmSources, optionsText: 'name', optionsValue: 'id', value: utmSource, disable: $parents[1].isReadOnly"></select>
                            </div>
                            <div class="form-group targeting-condition-mailing-list" data-bind="visible: ['dateSubscribed', 'dateUnsubscribed'].indexOf(field()) !== -1">
                                <label class="form-label">Mailing List</label>
                                <select class="input-select" data-bind="options: $parents[1].dateSubscribedMailingLists, optionsText: 'name', optionsValue: 'id', value: mailingListId, disable: $parents[1].isReadOnly"></select>
                            </div>
                        </div>
                        <div class="form-group targeting-condition-operator">
                            <label class="form-label">Operator</label>
                            <select class="input-select" data-bind="options: availableOperators, optionsText: 'label', optionsValue: 'id', value: operator, disable: $parents[1].isReadOnly"></select>
                        </div>
                        <div class="form-group targeting-condition-values" data-bind="visible: valueMode() !== 'none'">
                            <label class="form-label" data-bind="text: valueMode().indexOf('range') !== -1 ? 'Range' : (valueMode() === 'text' || valueMode().indexOf('multi') !== -1 ? 'Values' : 'Value')"></label>

                            <!-- ko if: valueMode() === 'text' -->
                            <textarea class="input-text" rows="3" data-bind="value: valuesInput, attr: { placeholder: valuePlaceholder }, disable: $parents[1].isReadOnly"></textarea>
                            <!-- /ko -->

                            <div class="targeting-date-filter" data-bind="visible: ['birthday-date', 'birthday-range', 'date', 'date-range'].indexOf(valueMode()) !== -1 && !$parents[1].isReadOnly(), css: { 'is-birthday': fieldType() === 'birthday' && repeatsEveryYear() }, template: { name: 'filterDate-template', data: dateFilter.getTemplateViewModel() }"></div>
                            <p class="form-text" data-bind="visible: ['birthday-date', 'birthday-range', 'date', 'date-range'].indexOf(valueMode()) !== -1 && $parents[1].isReadOnly(), text: valuesInput"></p>

                            <!-- ko if: valueMode() === 'number' -->
                            <input class="input-text" type="number" step="1" min="0" data-bind="value: valueOne, valueUpdate: 'input', disable: $parents[1].isReadOnly">
                            <!-- /ko -->

                            <!-- ko if: valueMode() === 'number-range' -->
                            <div class="targeting-value-range">
                                <label class="form-label">From</label>
                                <input class="input-text" type="number" step="1" min="0" data-bind="value: valueOne, valueUpdate: 'input', disable: $parents[1].isReadOnly">
                                <label class="form-label">To</label>
                                <input class="input-text" type="number" step="1" min="0" data-bind="value: valueTwo, valueUpdate: 'input', disable: $parents[1].isReadOnly">
                            </div>
                            <!-- /ko -->

                            <!-- ko if: valueMode() === 'boolean' -->
                            <select class="input-select" data-bind="value: valueOne, disable: $parents[1].isReadOnly">
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                            <!-- /ko -->

                            <!-- ko if: valueMode() === 'select' -->
                            <select class="input-select" data-bind="options: valueOptions, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select a value', value: valueOne, disable: $parents[1].isReadOnly"></select>
                            <!-- /ko -->

                            <!-- ko if: valueMode() === 'multi-select' -->
                            <select class="input-select targeting-value-multi-select" multiple size="4" data-bind="options: valueOptions, optionsText: 'name', optionsValue: 'id', selectedOptions: selectedValues, disable: $parents[1].isReadOnly"></select>
                            <!-- /ko -->

                            <!-- ko if: valueMode() === 'dropdown-multi' -->
                            <div class="targeting-value-dropdown-multi">
                                <select class="input-select" data-bind="options: valueOptions, optionsText: 'name', optionsValue: 'id', optionsCaption: valueDropdownCaption, value: valueToAdd, disable: $parents[1].isReadOnly"></select>
                                <div class="targeting-selected-values" data-bind="foreach: selectedValueOptions">
                                    <span class="targeting-selected-value">
                                        <span data-bind="text: name"></span>
                                        <button type="button" aria-label="Remove value" data-bind="visible: !$parents[2].isReadOnly(), event: { click: $parent.removeSelectedValue.bind($parent, id) }">&times;</button>
                                    </span>
                                </div>
                            </div>
                            <!-- /ko -->
                            <p class="form-text targeting-condition-help" data-bind="text: valueHelp"></p>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn border only-icon icon i-delete targeting-condition-remove" title="Remove Condition" aria-label="Remove Condition" data-bind="visible: !$parents[1].isReadOnly(), event: { click: $parents[1].removeCondition.bind($parents[1], $parent, $data) }"></button>
            </div>
        `;
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            fields: ko.observableArray([]),
            operators: ko.observableArray([]),
            utmSources: ko.observableArray([{id: '*', name: 'All'}]),
            dateSubscribedMailingLists: ko.observableArray([{id: '*', name: 'Any'}]),
            valueOptionsByField: ko.observable({}),
            rootCombinator: ko.observable('AND'),
            filterGroups: ko.observableArray([]),
            exclusionGroups: ko.observableArray([]),
            criteriaRevision: ko.observable(0),
            externalEmailsInput: ko.observable(''),
            isReadOnly: ko.observable(false),
            uniqueId: ko.observable(Math.floor(Math.random() * 1000000)),
            addFilterGroup: function () {
                self.addFilterGroup();
            },
            addExclusionGroup: function () {
                self.addExclusionGroup();
            },
            addCondition: function (group: any) {
                self.addCondition(group);
            },
            removeFilterGroup: function (group: any) {
                self.removeFilterGroup(group);
            },
            removeExclusionGroup: function (group: any) {
                self.removeExclusionGroup(group);
            },
            removeCondition: function (group: any, condition: any) {
                self.removeCondition(group, condition);
            },
            isUtmSourceField: function (fieldId: string) {
                return self.isUtmSourceField(fieldId);
            },
            isEmailField: function (fieldId: string) {
                return fieldId === 'email';
            }
        };
    }

    protected getTemplateName(): string {
        return "newsletterTargetingBuilder_template";
    }

    public setReferences(references: any): void {
        let fields = [];
        for (let id in (references.fields || {})) {
            if (references.fields[id].hidden) {
                continue;
            }
            fields.push({
                id: id,
                label: references.fields[id].label,
                type: references.fields[id].type || '',
                utmSource: references.fields[id].utmSource || null,
                placeholder: references.fields[id].placeholder || '',
                help: references.fields[id].help || ''
            });
        }
        let operators = [];
        for (let id in (references.operators || {})) {
            operators.push({
                id: id,
                label: references.operators[id].label,
                types: references.operators[id].types || []
            });
        }

        let seenUtmSources: any = {'*': true};
        let utmSources = [{id: '*', name: 'All'}];
        (references.utmSources || []).forEach((source: any) => {
            let value = source.id || source.name;
            if (!value || seenUtmSources[value]) {
                return;
            }
            seenUtmSources[value] = true;
            utmSources.push({id: value, name: source.name || value});
        });

        let valueOptionsByField: any = Object.assign({}, this.getTemplateViewModel().valueOptionsByField(), {
            segment: this.normalizeReferenceOptions(references.segments || [], 'title'),
            campaign: this.normalizeReferenceOptions(references.campaigns || [], 'name'),
            mailingList: this.normalizeReferenceOptions(references.mailingLists || [], 'name')
        });
        let profileOptions = references.profileOptions || {};
        for (let fieldId in profileOptions) {
            valueOptionsByField[fieldId] = this.normalizeReferenceOptions(profileOptions[fieldId] || [], 'name');
            this.loadedProfileOptionFields[fieldId] = true;
        }

        this.getTemplateViewModel().fields(fields);
        this.getTemplateViewModel().operators(operators);
        this.getTemplateViewModel().utmSources(utmSources);
        this.getTemplateViewModel().dateSubscribedMailingLists(
            [{id: '*', name: 'Any'}].concat(this.normalizeReferenceOptions(references.mailingLists || [], 'name'))
        );
        this.getTemplateViewModel().valueOptionsByField(valueOptionsByField);
        this.ensureAllConditionOperators();
    }

    private isUtmSourceField(fieldId: string): boolean {
        let field = this.getTemplateViewModel().fields().find((item: any) => item.id === fieldId);
        return !!(field && field.type && field.type.indexOf('utm') === 0);
    }

    public setReadOnly(isReadOnly: boolean): void {
        this.getTemplateViewModel().isReadOnly(isReadOnly);
    }

    public setCriteria(criteria: any): void {
        criteria = criteria || {};
        let rootCombinator = this.normalizeCombinator(criteria.combinator || 'AND');
        this.getTemplateViewModel().rootCombinator(rootCombinator);
        this.getTemplateViewModel().filterGroups((criteria.filterGroups || criteria.groups || []).map((group: any, index: number) => this.createGroup(group, index === 0 ? 'AND' : rootCombinator)));
        this.getTemplateViewModel().exclusionGroups((criteria.exclusionGroups || []).map((group: any) => this.createGroup(group)));
        this.getTemplateViewModel().externalEmailsInput('');
    }

    public getCriteria(): any {
        let filterGroups = this.getTemplateViewModel().filterGroups().map((group: any) => this.serializeGroup(group));
        return {
            version: 1,
            combinator: filterGroups.length > 1 ? filterGroups[1].joinWithPrevious : this.getTemplateViewModel().rootCombinator(),
            filterGroups: filterGroups,
            exclusionGroups: this.getTemplateViewModel().exclusionGroups().map((group: any) => this.serializeGroup(group)),
            externalEmails: []
        };
    }

    public addFilterGroup(): void {
        let groups = this.getTemplateViewModel().filterGroups();
        this.getTemplateViewModel().filterGroups.push(this.createGroup({
            joinWithPrevious: groups.length ? this.getTemplateViewModel().rootCombinator() : 'AND'
        }));
        this.markCriteriaChanged();
    }

    public addExclusionGroup(): void {
        this.getTemplateViewModel().exclusionGroups.push(this.createGroup());
        this.markCriteriaChanged();
    }

    public addCondition(group: any): void {
        group.conditions.push(this.createCondition());
        this.markCriteriaChanged();
    }

    public removeFilterGroup(group: any): void {
        this.getTemplateViewModel().filterGroups.remove(group);
        this.markCriteriaChanged();
    }

    public removeExclusionGroup(group: any): void {
        this.getTemplateViewModel().exclusionGroups.remove(group);
        this.markCriteriaChanged();
    }

    public removeCondition(group: any, condition: any): void {
        group.conditions.remove(condition);
        this.markCriteriaChanged();
    }

    private createGroup(group: any = null, fallbackJoinWithPrevious: string = 'AND'): any {
        group = group || {};
        let conditions = (group.conditions || []).map((condition: any) => this.createCondition(condition));

        let groupViewModel = {
            joinWithPrevious: ko.observable(this.normalizeCombinator(group.joinWithPrevious || fallbackJoinWithPrevious)),
            combinator: ko.observable(group.combinator || 'AND'),
            conditions: ko.observableArray(conditions.length ? conditions : [this.createCondition()])
        };
        groupViewModel.joinWithPrevious.subscribe(() => this.markCriteriaChanged());
        groupViewModel.combinator.subscribe(() => this.markCriteriaChanged());

        return groupViewModel;
    }

    private createCondition(condition: any = null): any {
        condition = condition || {};
        let values = condition.values || condition.value || [];
        if (!Array.isArray(values)) {
            values = [values];
        }
        values = values.map((value: any) => value === null || value === undefined ? '' : String(value));
        let fieldId = this.normalizeUtmField(condition.field || 'email');
        let repeatsEveryYear = false;
        if (fieldId === 'isPremium') {
            values = values.map((value: string) => ['1', 'true', 'yes'].indexOf(value.toLowerCase()) !== -1 ? '1' : '0');
        } else if (fieldId === 'birthday') {
            repeatsEveryYear = Object.prototype.hasOwnProperty.call(condition, 'repeatsEveryYear')
                ? !!condition.repeatsEveryYear
                : values.some((value: string) => /^\d{2}-\d{2}$/.test(value) || /^[+-]?\d+(?:y|m|w|d)/i.test(value));
            if (repeatsEveryYear) {
                values = values.map((value: string) => this.formatBirthdayDate(value));
            }
        }
        let conditionViewModel: any = {
            field: ko.observable(fieldId),
            operator: ko.observable(condition.operator || 'equals'),
            valuesInput: ko.observable(values.join(', ')),
            valueOne: ko.observable(values[0] || ''),
            valueTwo: ko.observable(values[1] || ''),
            valueToAdd: ko.observable(''),
            selectedValues: ko.observableArray(values.filter((value: string) => value !== '')),
            utmSource: ko.observable(condition.utmSource || '*'),
            mailingListId: ko.observable(
                condition.mailingListId === null || condition.mailingListId === undefined || condition.mailingListId === ''
                    ? '*'
                    : String(condition.mailingListId)
            ),
            includeExternalUsers: ko.observable(!!condition.includeExternalUsers || !!condition.includeExternal),
            repeatsEveryYear: ko.observable(repeatsEveryYear)
        };
        let dateFilterCaller = Object.create(this.caller);
        dateFilterCaller.filterDateOnChange = () => this.markCriteriaChanged();
        let dateFilter = new filterDate_template(this.idElement + 'DateFilter' + (++this.dateFilterId), conditionViewModel, dateFilterCaller);
        dateFilter.setLabel('Date');
        dateFilter.setStartPickerId(dateFilter.idElement + 'Start');
        dateFilter.setEndPickerId(dateFilter.idElement + 'End');
        dateFilter.toggleClearButton(true);
        conditionViewModel.dateFilter = dateFilter;
        let dateFilterViewModel = dateFilter.getTemplateViewModel();
        let birthdayYears: any = {};
        let normalizeBirthdayDates = () => {
            if (conditionViewModel.fieldType() !== 'birthday' || !conditionViewModel.repeatsEveryYear()) {
                return;
            }
            ['startDate', 'endDate', 'lastStartDate', 'lastEndDate'].forEach((property: string) => {
                let observable = dateFilterViewModel[property];
                if (observable()) {
                    let value = String(observable());
                    let year = value.match(/^(\d{4})-/);
                    if (year) {
                        birthdayYears[property] = year[1];
                    }
                    observable(this.formatBirthdayDate(value));
                }
            });
        };
        let prepareBirthdayDates = () => {
            if (conditionViewModel.fieldType() !== 'birthday') {
                return;
            }
            ['startDate', 'endDate', 'lastStartDate', 'lastEndDate'].forEach((property: string) => {
                let observable = dateFilterViewModel[property];
                if (observable()) {
                    observable(this.toBirthdayPickerDate(observable(), birthdayYears[property]));
                }
            });
        };
        let configureBirthdayCalendars = () => {
            [dateFilter.calendar1, dateFilter.calendar2].forEach((calendar: any) => {
                if (calendar && calendar.base) {
                    calendar.base.classList.toggle(
                        'targeting-birthday-calendar',
                        conditionViewModel.fieldType() === 'birthday' && conditionViewModel.repeatsEveryYear()
                    );
                }
            });
        };
        let openDateFilter = (callback: any) => (data: any, event: any) => {
            callback(data, event);
            requestAnimationFrame(() => {
                prepareBirthdayDates();
                dateFilter.buildCalendar();
                normalizeBirthdayDates();
                configureBirthdayCalendars();
            });
        };
        dateFilterViewModel.toggle = openDateFilter(dateFilterViewModel.toggle);
        dateFilterViewModel.onClickEdit = openDateFilter(dateFilterViewModel.onClickEdit);
        let applyDateFilter = dateFilterViewModel.apply;
        dateFilterViewModel.apply = (data: any, event: any) => {
            applyDateFilter(data, event);
            normalizeBirthdayDates();
        };
        let cancelDateFilter = dateFilterViewModel.onClickCancel;
        dateFilterViewModel.onClickCancel = (data: any, event: any) => {
            prepareBirthdayDates();
            cancelDateFilter(data, event);
            normalizeBirthdayDates();
        };

        conditionViewModel.fieldDefinition = ko.pureComputed(() => {
            return this.getFieldDefinition(conditionViewModel.field());
        });
        conditionViewModel.fieldType = ko.pureComputed(() => {
            let fieldDefinition = conditionViewModel.fieldDefinition();
            return fieldDefinition ? fieldDefinition.type : 'string';
        });
        conditionViewModel.availableOperators = ko.pureComputed(() => {
            let fieldType = conditionViewModel.fieldType();
            return this.getTemplateViewModel().operators().filter((operatorOption: any) => {
                return (operatorOption.types || []).indexOf(fieldType) !== -1;
            });
        });
        conditionViewModel.valueOptions = ko.pureComputed(() => {
            return this.getTemplateViewModel().valueOptionsByField()[conditionViewModel.field()] || [];
        });
        conditionViewModel.selectedValueOptions = ko.pureComputed(() => {
            let optionsById: any = {};
            conditionViewModel.valueOptions().forEach((option: any) => optionsById[option.id] = option);
            return conditionViewModel.selectedValues().map((value: string) => {
                return optionsById[value] || {id: value, name: value};
            });
        });
        conditionViewModel.removeSelectedValue = (value: string) => {
            conditionViewModel.selectedValues.remove(value);
        };
        conditionViewModel.valueMode = ko.pureComputed(() => {
            return this.getConditionValueMode(conditionViewModel);
        });
        conditionViewModel.valuePlaceholder = ko.pureComputed(() => {
            let fieldDefinition = conditionViewModel.fieldDefinition();
            return fieldDefinition && fieldDefinition.placeholder
                ? fieldDefinition.placeholder
                : 'Enter values separated by commas';
        });
        conditionViewModel.valueDropdownCaption = ko.pureComputed(() => {
            let fieldDefinition = conditionViewModel.fieldDefinition();
            return 'Select ' + (fieldDefinition ? fieldDefinition.label.toLowerCase() : 'a value');
        });
        conditionViewModel.valueHelp = ko.pureComputed(() => {
            return this.getConditionValueHelp(conditionViewModel);
        });
        conditionViewModel.showExternalUsers = ko.pureComputed(() => {
            return conditionViewModel.field() === 'email'
                && ['equals', 'is_any_of'].indexOf(conditionViewModel.operator()) !== -1;
        });
        conditionViewModel.ensureOperator = () => {
            let availableOperators = conditionViewModel.availableOperators();
            let isAllowed = availableOperators.some((operatorOption: any) => operatorOption.id === conditionViewModel.operator());
            if (!isAllowed && availableOperators.length) {
                conditionViewModel.operator(availableOperators[0].id);
            }
        };
        conditionViewModel.field.subscribe(() => {
            conditionViewModel.valuesInput('');
            conditionViewModel.valueOne('');
            conditionViewModel.valueTwo('');
            conditionViewModel.valueToAdd('');
            conditionViewModel.selectedValues([]);
            dateFilter.reset();
            let selectedField = this.getFieldDefinition(conditionViewModel.field());
            dateFilter.setLabel(selectedField && selectedField.type === 'birthday' ? 'Birthday' : 'Date');
            conditionViewModel.utmSource('*');
            conditionViewModel.mailingListId('*');
            conditionViewModel.includeExternalUsers(false);
            conditionViewModel.repeatsEveryYear(false);
            conditionViewModel.ensureOperator();
            this.loadProfileOptions(conditionViewModel.field());
            this.markCriteriaChanged();
        });
        conditionViewModel.operator.subscribe(() => {
            if (!conditionViewModel.showExternalUsers()) {
                conditionViewModel.includeExternalUsers(false);
            }
            this.markCriteriaChanged();
        });
        conditionViewModel.valuesInput.subscribe((value: string) => {
            let selectedValues = this.splitValues(value);
            if (conditionViewModel.selectedValues().join(',') !== selectedValues.join(',')) {
                conditionViewModel.selectedValues(selectedValues);
            }
            this.markCriteriaChanged();
        });
        conditionViewModel.selectedValues.subscribe((selectedValues: Array<string>) => {
            let value = (selectedValues || []).join(', ');
            if (conditionViewModel.valuesInput() !== value) {
                conditionViewModel.valuesInput(value);
            }
            conditionViewModel.valueOne(selectedValues && selectedValues.length ? selectedValues[0] : '');
        });
        conditionViewModel.valueToAdd.subscribe((value: string) => {
            if (!value) {
                return;
            }
            if (conditionViewModel.selectedValues().indexOf(value) === -1) {
                conditionViewModel.selectedValues.push(value);
            }
            conditionViewModel.valueToAdd('');
        });
        conditionViewModel.valueOne.subscribe((value: string) => {
            let valueMode = conditionViewModel.valueMode();
            let usesSingleValueControl = ['date', 'date-range', 'number', 'number-range', 'boolean', 'select'].indexOf(valueMode) !== -1;
            // Knockout's number input can provide numeric zero rather than "0".
            let normalizedValue = value === null || value === undefined ? '' : String(value);
            if (usesSingleValueControl && conditionViewModel.valuesInput() !== normalizedValue) {
                conditionViewModel.valuesInput(normalizedValue);
            }
        });
        conditionViewModel.valueTwo.subscribe(() => this.markCriteriaChanged());
        conditionViewModel.utmSource.subscribe(() => this.markCriteriaChanged());
        conditionViewModel.mailingListId.subscribe(() => this.markCriteriaChanged());
        conditionViewModel.includeExternalUsers.subscribe(() => this.markCriteriaChanged());
        conditionViewModel.repeatsEveryYear.subscribe((repeats: boolean) => {
            if (conditionViewModel.fieldType() !== 'birthday') {
                return;
            }
            if (repeats) {
                normalizeBirthdayDates();
            } else {
                prepareBirthdayDates();
            }
            configureBirthdayCalendars();
            this.markCriteriaChanged();
        });

        conditionViewModel.ensureOperator();
        let fieldDefinition = conditionViewModel.fieldDefinition();
        dateFilter.setLabel(fieldDefinition && fieldDefinition.type === 'birthday' ? 'Birthday' : 'Date');
        if (fieldDefinition && ['birthday', 'date', 'utmDate'].indexOf(fieldDefinition.type) !== -1 && values.length) {
            if (/^[+-]?\d+(?:y|m|w|d)/i.test(values[0])) {
                dateFilter.getTemplateViewModel().selectedFilter('range');
                dateFilter.setRange(values[0], values[1] || null);
            } else {
                let dateViewModel = dateFilter.getTemplateViewModel();
                let startDate = fieldDefinition.type === 'birthday' ? this.toBirthdayPickerDate(values[0]) : values[0];
                let endDate = fieldDefinition.type === 'birthday' && values[1] ? this.toBirthdayPickerDate(values[1]) : values[1] || null;
                dateViewModel.startDate(startDate);
                dateViewModel.endDate(endDate);
                dateViewModel.lastStartDate(startDate);
                dateViewModel.lastEndDate(endDate);
                dateViewModel.isActive(false);
            }
        } else {
            dateFilter.reset();
        }
        normalizeBirthdayDates();
        this.loadProfileOptions(conditionViewModel.field());

        return conditionViewModel;
    }

    private loadProfileOptions(field: string): void {
        if (['gender', 'ageGroup', 'state', 'country', 'continent', 'ipInferredCity', 'ipInferredState', 'ipInferredCountry', 'ipInferredContinent'].indexOf(field) === -1 || this.loadedProfileOptionFields[field]) {
            return;
        }

        this.loadedProfileOptionFields[field] = true;
        this.caller.loadProfileOptions(field, (options: Array<any>) => {
            let valueOptionsByField = this.getTemplateViewModel().valueOptionsByField();
            valueOptionsByField[field] = this.normalizeReferenceOptions(options || [], 'name');
            this.getTemplateViewModel().valueOptionsByField(valueOptionsByField);
        });
    }

    private serializeGroup(group: any): any {
        return {
            joinWithPrevious: group.joinWithPrevious ? this.normalizeCombinator(group.joinWithPrevious()) : 'AND',
            combinator: this.normalizeCombinator(group.combinator()),
            conditions: group.conditions().map((condition: any) => {
                let serializedCondition: any = {
                    field: condition.field(),
                    operator: condition.operator(),
                    values: this.getConditionValues(condition),
                    utmSource: this.isUtmSourceField(condition.field()) ? condition.utmSource() : null,
                    includeExternalUsers: condition.showExternalUsers() && condition.includeExternalUsers()
                };
                if (condition.fieldType() === 'birthday') {
                    serializedCondition.repeatsEveryYear = condition.repeatsEveryYear();
                }
                if (['dateSubscribed', 'dateUnsubscribed'].indexOf(condition.field()) !== -1) {
                    serializedCondition.mailingListId = condition.mailingListId();
                }
                return serializedCondition;
            })
        };
    }

    private getConditionValueMode(condition: any): string {
        let operator = condition.operator();
        if (operator === 'is_blank' || operator === 'is_not_blank') {
            return 'none';
        }

        let fieldType = condition.fieldType();
        if (fieldType === 'boolean') {
            return 'boolean';
        }
        if (fieldType === 'birthday') {
            return operator === 'between' ? 'birthday-range' : 'birthday-date';
        }
        if (fieldType === 'date' || fieldType === 'utmDate') {
            return operator === 'between' ? 'date-range' : 'date';
        }
        if (fieldType === 'number' || fieldType === 'utmNumber') {
            return operator === 'between' ? 'number-range' : 'number';
        }
        if (fieldType === 'campaign') {
            return 'dropdown-multi';
        }
        if (['segment', 'mailingList'].indexOf(fieldType) !== -1) {
            return 'multi-select';
        }
        if (condition.valueOptions().length) {
            if (operator === 'is_any_of' || operator === 'is_none_of') {
                if (['country', 'ipInferredCountry'].indexOf(condition.field()) !== -1) {
                    return 'dropdown-multi';
                }
                return 'multi-select';
            }
            if (operator === 'equals' || operator === 'not_equals') {
                return 'select';
            }
        }

        return 'text';
    }

    private markCriteriaChanged(): void {
        let revision = this.getTemplateViewModel().criteriaRevision;
        revision(revision() + 1);
    }

    private getConditionValueHelp(condition: any): string {
        let fieldDefinition = condition.fieldDefinition();
        let fieldHelp = fieldDefinition && fieldDefinition.help ? fieldDefinition.help : '';
        let operator = condition.operator();
        let fieldType = condition.fieldType();
        let isDate = fieldType === 'birthday' || fieldType === 'date' || fieldType === 'utmDate';
        let isUtm = fieldType.indexOf('utm') === 0;
        let operatorHelp = '';

        if (operator === 'is_blank') {
            operatorHelp = isUtm
                ? 'No value is required. Matches users with no selected-source engagement value.'
                : 'No value is required. Matches users whose field is empty or missing.';
        } else if (operator === 'is_not_blank') {
            operatorHelp = isUtm
                ? 'No value is required. Matches users with an engagement record containing this value.'
                : 'No value is required. Matches users whose field has a value.';
        } else if (operator === 'between') {
            operatorHelp = 'Choose both From and To values. The range includes both endpoints.';
        } else if (operator === 'greater_than') {
            operatorHelp = isDate ? 'Matches dates after the selected date.' : 'Matches counts above the entered number.';
        } else if (operator === 'less_than') {
            operatorHelp = isDate ? 'Matches dates before the selected date.' : 'Matches counts below the entered number.';
        } else if (operator === 'greater_or_equal') {
            operatorHelp = isDate ? 'Matches the selected date and later dates.' : 'Matches the entered count or higher.';
        } else if (operator === 'less_or_equal') {
            operatorHelp = isDate ? 'Matches the selected date and earlier dates.' : 'Matches the entered count or lower.';
        } else if (operator === 'contains_any_of') {
            operatorHelp = 'Separate search terms with commas. A field matches when it contains any one of them.';
        } else if (operator === 'does_not_contain_any_of') {
            operatorHelp = 'Separate search terms with commas. A field matches only when it contains none of them.';
        } else if (operator === 'is_any_of' || operator === 'is_none_of') {
            if (condition.valueMode() === 'dropdown-multi') {
                operatorHelp = 'Choose options from the dropdown one at a time. Selected values appear below.';
            } else {
                operatorHelp = condition.valueMode() === 'multi-select'
                    ? 'Select one or more options. Use Command/Ctrl to select multiple items.'
                    : 'Separate multiple values with commas.';
            }
        } else if (operator === 'equals' && condition.valueMode() === 'text') {
            operatorHelp = 'Separate multiple values with commas. Matching any one exact value is sufficient.';
        } else if (operator === 'not_equals' && condition.valueMode() === 'text') {
            operatorHelp = 'Separate multiple values with commas. Users matching any entered exact value are excluded.';
        } else if ((operator === 'equals' || operator === 'not_equals') && isDate) {
            operatorHelp = 'The comparison uses the selected calendar date, not a time of day.';
        }
        if (isDate && operator === 'between') {
            operatorHelp += ' Use Range mode for a moving date such as -30d.';
        }

        if (operator === 'is_blank' || operator === 'is_not_blank') {
            return operatorHelp;
        }
        if (condition.field() === 'email' && ['contains_any_of', 'does_not_contain_any_of'].indexOf(operator) !== -1) {
            fieldHelp = 'Enter an email fragment such as @example.com or part of an address.';
        } else if (condition.valueOptions().length && condition.valueMode() === 'text') {
            fieldHelp = 'Enter text to search within the stored ' + fieldDefinition.label.toLowerCase() + ' value.';
        }

        return [fieldHelp, operatorHelp].filter((text: string) => text !== '').join(' ');
    }

    private getConditionValues(condition: any): Array<string> {
        let valueMode = condition.valueMode();
        if (valueMode === 'none') {
            return [];
        }
        if (valueMode === 'multi-select' || valueMode === 'dropdown-multi') {
            return (condition.selectedValues() || []).filter((value: string) => value !== '');
        }
        if (['birthday-date', 'birthday-range', 'date', 'date-range'].indexOf(valueMode) !== -1) {
            let dateViewModel = condition.dateFilter.getTemplateViewModel();
            let dateValues = dateViewModel.selectedFilter() === 'range'
                ? [dateViewModel.fromRange(), dateViewModel.toRange()]
                : [dateViewModel.startDate(), dateViewModel.endDate()];
            dateValues = dateValues.filter((value: string) => value !== null && value !== '');
            if (valueMode.indexOf('birthday') === 0 && condition.repeatsEveryYear()) {
                dateValues = dateValues.map((value: string) => this.formatBirthdayDate(value));
            }
            return valueMode.indexOf('range') !== -1 ? dateValues : dateValues.slice(0, 1);
        }
        if (valueMode === 'number-range') {
            return [condition.valueOne(), condition.valueTwo()].filter((value: string) => value !== '');
        }
        if (['number', 'boolean', 'select'].indexOf(valueMode) !== -1) {
            return condition.valueOne() === '' ? [] : [String(condition.valueOne())];
        }

        return this.splitValues(condition.valuesInput());
    }

    private getFieldDefinition(fieldId: string): any {
        return this.getTemplateViewModel().fields().find((field: any) => field.id === fieldId) || null;
    }

    private formatBirthdayDate(value: string): string {
        return String(value).replace(/^\d{4}-/, '');
    }

    private toBirthdayPickerDate(value: string, year: string = '2000'): string {
        value = String(value);
        return /^\d{4}-/.test(value) ? value : year + '-' + value;
    }

    private ensureAllConditionOperators(): void {
        ['filterGroups', 'exclusionGroups'].forEach((groupType: string) => {
            this.getTemplateViewModel()[groupType]().forEach((group: any) => {
                group.conditions().forEach((condition: any) => condition.ensureOperator());
            });
        });
    }

    private normalizeReferenceOptions(items: Array<any>, labelField: string): Array<any> {
        return (items || []).map((item: any) => {
            let id = item && item.id !== undefined ? item.id : null;
            let name = item && item[labelField] !== undefined ? item[labelField] : (item ? item.name : null);
            return {
                id: id === null ? '' : String(id),
                name: name === null || name === undefined ? '' : String(name)
            };
        }).filter((item: any) => item.id !== '' && item.name !== '');
    }

    private splitValues(value: string): Array<string> {
        if (!value) {
            return [];
        }

        return value.split(',').map((item) => item.trim()).filter((item) => item !== '');
    }

    private normalizeCombinator(value: string): string {
        return value === 'OR' ? 'OR' : 'AND';
    }

    private normalizeUtmField(fieldId: string): string {
        let aliases: any = {
            lastClickAllUtm: 'lastClickByUtm',
            lastOpenAllUtm: 'lastOpenByUtm',
            clicksLast7AllUtm: 'clicksLast7ByUtm',
            opensLast7AllUtm: 'opensLast7ByUtm',
            clicksLast30AllUtm: 'clicksLast30ByUtm',
            opensLast30AllUtm: 'opensLast30ByUtm'
        };

        return aliases[fieldId] || fieldId;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterTargetingBuilder_template.ts